"use client";

import { Link } from "react-router-dom";
import { Logo, Button, Text } from "@/src/components";
import {
  BarChart3,
  LayoutDashboard,
  Sparkles,
  Bot,
  Palette,
  Book,
} from "lucide-react";

const features = [
  {
    icon: <Book className="h-5 w-5" />,
    title: "Documentation",
    description: "60+ components with live examples",
    href: "/docs",
    color: "text-blue-500",
  },
  {
    icon: <BarChart3 className="h-5 w-5" />,
    title: "Charts",
    description: "ECharts-based data visualization",
    href: "/docs/charts",
    color: "text-violet-500",
  },
  {
    icon: <LayoutDashboard className="h-5 w-5" />,
    title: "Page Templates",
    description: "Dashboard, Listing, Detail, Approval, Settings",
    href: "/docs/templates/dashboard",
    color: "text-emerald-500",
  },
  {
    icon: <Sparkles className="h-5 w-5" />,
    title: "Motion Design",
    description: "Animations, transitions, micro-interactions",
    href: "/docs/motion",
    color: "text-amber-500",
  },
  {
    icon: <Palette className="h-5 w-5" />,
    title: "6 Themes",
    description: "Including Glassmorphic, Neumorphic, High Contrast",
    href: "/docs/themes",
    color: "text-pink-500",
  },
  {
    icon: <Bot className="h-5 w-5" />,
    title: "AI Instructions",
    description: "Boilerplate guide for AI-powered development",
    href: "/docs/ai/boilerplate",
    color: "text-cyan-500",
  },
];

export default function HomePage() {
  return (
    <div className="h-full flex flex-col items-center justify-center gap-theme-6 px-theme-6 overflow-auto py-12">
      {/* Hero */}
      <div className="flex flex-col items-center gap-theme-4 animate-fade-in-up">
        <Logo size={64} />
        <Text as="h1" className="text-h1 font-bold">
          Dream Light
        </Text>
        <Text className="text-lg text-muted-foreground text-center max-w-lg">
          A production-grade design system for finance process applications — built with React, Tailwind CSS, and shadcn/ui
        </Text>
      </div>

      {/* CTA */}
      <div className="flex gap-theme-4 animate-fade-in-up delay-2">
        <Link to="/docs">
          <Button size="lg">View Documentation</Button>
        </Link>
        <Link to="/docs/templates/dashboard">
          <Button size="lg" variant="outline">
            Explore Templates
          </Button>
        </Link>
      </div>

      {/* Feature Grid */}
      <div className="stagger-children grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-theme-4 max-w-4xl w-full">
        {features.map((feature) => (
          <Link
            key={feature.title}
            to={feature.href}
            className="group flex gap-theme-4 items-start p-theme-5 rounded-theme-lg border-theme bg-theme-card hover:shadow-theme-lg transition-all duration-200"
          >
            <div className={`mt-0.5 ${feature.color}`}>{feature.icon}</div>
            <div>
              <Text as="p" className="font-semibold text-sm group-hover:text-primary transition-colors">
                {feature.title}
              </Text>
              <Text as="p" className="text-xs text-muted-foreground mt-0.5">
                {feature.description}
              </Text>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
